import { render, staticRenderFns } from "./PopUpGPT.vue?vue&type=template&id=3eebb666&scoped=true"
import script from "./PopUpGPT.vue?vue&type=script&lang=js"
export * from "./PopUpGPT.vue?vue&type=script&lang=js"
import style0 from "./PopUpGPT.vue?vue&type=style&index=0&id=3eebb666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eebb666",
  null
  
)

export default component.exports